<template>
  <!-- TAB列表 -->
  <div id="tablisst">
    <van-tabs class="tabs" @click="tabClick" :class="{ 'onetab' : tablist.annual_ranking == undefined }" v-model="tabActive" :line-height="3" :line-width="80" title-inactive-color="#000" title-active-color="#000">
        <van-tab v-if="tablist.annual_ranking" class="tabitem" :title="tablist.annual_ranking.title" :class="{ tabsActive: tabActive==0 }">
            <NewsItem
                class="newsitem"
                v-for="(item, index) in tablist.annual_ranking.list"
                :tab-id="1"
                :key="index"
                v-bind="item"
            />
            <template v-if="tablist.annual_ranking.list.length==0">
                <div class="no-content">————    暂无内容    ————</div>
            </template>
        </van-tab>
        <van-tab v-if="tablist.annual_report" class="tabitem" :title="tablist.annual_report.title" :class="{ tabsActive: tabActive==1 }">
            <NewsItem
                class="newsitem"
                v-for="(item, index) in tablist.annual_report.list"
                :tab-id="2"
                :key="index"
                v-bind="item"
            />
            <template v-if="tablist.annual_report.list.length==0">
                <div class="no-content">————    暂无内容    ————</div>
            </template>
        </van-tab>
        <van-tab v-if="tablist.media_coverage" class="tabitem" :title="tablist.media_coverage.title" :class="{ tabsActive: tabActive==2 }">
            <NewsItem
                class="newsitem"
                v-for="(item, index) in tablist.media_coverage.list"
                :tab-id="3"
                :key="index"
                v-bind="item"
            />
            <template v-if="tablist.media_coverage.list.length==0">
                <div class="no-content">————    暂无内容    ————</div>
            </template>
        </van-tab>
        <van-tab v-if="tablist.theoretical_basis" class="tabitem" :title="tablist.theoretical_basis.title" :class="{ tabsActive: tabActive==3 }">
            <NewsItem
                class="newsitem"
                v-for="(item, index) in tablist.theoretical_basis.list"
                :tab-id="4"
                :key="index"
                v-bind="item"
            />
            <template v-if="tablist.theoretical_basis.list.length==0">
                <div class="no-content">————    暂无内容    ————</div>
            </template>
        </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import DigitalItem from '@/components/DigitalItem'
import NewsItem from '@/components/NewsItem'
export default {
    components:{
        'van-tabs':Tabs,
        'van-tab':Tab,
        DigitalItem,
        NewsItem
    },
    data(){
        return {
            tabActive:0
        }
    },
    props: ['tablist'],
    mounted(){
        console.log(this.tablist)
    },
    methods:{
        tabClick(e) {
            this.tabActive = e
        },
        loadmore(){
            console.log('点击更多。。')
        },
        onNewsItemClick(id) {
			let query = {
				newsId: id
			}
			if (this.selectedNavItemId !== 1) {
				query.cate_id = this.selectedNavItemId
			}
			this.$router.push({ query })
		},
        onClick() {
            console.log('123456--')
        }
    }

}
</script>

<style  lang="stylus" scoped>

</style>
<style  lang="stylus">
#tablisst{
    margin-top:30px;
    .van-tabs{
        .van-tabs__wrap{
            width: 690px;
            margin: 30px auto 10px auto;;
            border-bottom: solid 1px #d9d9d9;
            .van-tabs__nav{
                .van-tabs__line{
                    // background-color: #41719C;
                }
                .van-tab{
                    .van-ellipsis{
                        font-weight:600
                    }
                    .van-tab__text--ellipsis{
                        overflow: inherit;
                    }
                }
            }
        }
        .van-tabs__content{
            overflow-y: auto;
            .tabitem{
                padding: 0px 15px 40px 15px;
                .items{
                    margin: 30px 15px 15px 15px;
                }
            }
            .tabsHeight, .tabsActive{
                height: 500px;
            }
            .no-content {
                height: 300px;
                line-height: 300px;
                color: #999;
                text-align: center;
                margin-bottom: 30px;
            }
        }
    }
    .onetab{
        .van-tabs__wrap .van-tabs__nav{
            .van-tabs__line{
                transform: translateX(3px) !important;
            }
            .van-tab .van-tab__text{
                text-align: left;
                width: 100%;
            }
            .van-tab .van-ellipsis{
                text-align: left;
            }
        }
    }
}
</style>